export const qris = [
    {
      name: "BCA",
      start_date: "1",
      image: "/qrish_bca.png",
      code_qris: "00020101021126650013ID.CO.BCA.WWW011893600014000116620002150008850011662000303UKE51440014ID.CO.QRIS.WWW0215ID10210670742570303UKE5204546253033605802ID5915ROTI SENDOWO-HO6006MALANG61056512662070703A0163040802"
    },
    {
      name: "MASBF SEMAR",
      start_date: "11",
      image: "/qrish_masbf_semar.png",
      code_qris: "00020101021126690017ID.CO.BANKMAS.WWW01189360054810000114520215ID10250001141820303UMI51440014ID.CO.QRIS.WWW0215ID10253775806710303UMI5204546253033605802ID5905SEMAR6006MALANG61056515362070703A0163040F16"
    },
    {
      name: "MASBF SEMAR",
      start_date: "21",
      image: "/qrish_masbf_semar.png",
      code_qris: "00020101021126690017ID.CO.BANKMAS.WWW01189360054810000114520215ID10250001141820303UMI51440014ID.CO.QRIS.WWW0215ID10253775806710303UMI5204546253033605802ID5905SEMAR6006MALANG61056515362070703A0163040F16"
    },
];

export const selectedQris = (date) => {
    // Gunakan tanggal hari ini atau tanggal transaksi
    const today = new Date(date);
    const dateToday = today.getDate();

    // Urutkan qris descending berdasarkan start_date agar pencarian benar
    const sortedQris = [...qris].sort((a, b) => b.start_date - a.start_date);

    // Cari qris dengan start_date <= date
    return sortedQris.find(qr => dateToday >= Number(qr.start_date)) || qris[0];
  }
    